import React from 'react';
import { useTranslation } from 'react-i18next';
import { WEEK_DAYS } from '../../lib/data/verticalPresets';

// Paso 4 — Horarios. Checkboxes de días + apertura/cierre. Toggle "Personalizar
// por día" muestra una fila por día activo con horario individual.
function StepHours({ state, errors, onChange }) {
  const { t } = useTranslation();
  const hours = state.hours || { days: [], openTime: '09:00', closeTime: '18:00', customPerDay: null };
  const custom = hours.customPerDay;

  const dayLabel = (key) => t(`setupWizard.days.${key}`, key);

  const toggleDay = (value) => {
    const active = hours.days.includes(value);
    const days = active ? hours.days.filter((d) => d !== value) : [...hours.days, value];
    let customPerDay = custom;
    if (custom) {
      customPerDay = { ...custom };
      if (active) delete customPerDay[value];
      else customPerDay[value] = { openTime: hours.openTime, closeTime: hours.closeTime };
    }
    onChange({ ...hours, days, customPerDay });
  };

  const setGlobalTime = (field, value) => {
    onChange({ ...hours, [field]: value });
  };

  const toggleCustom = (enabled) => {
    if (enabled) {
      const customPerDay = {};
      hours.days.forEach((d) => {
        customPerDay[d] = { openTime: hours.openTime, closeTime: hours.closeTime };
      });
      onChange({ ...hours, customPerDay });
    } else {
      onChange({ ...hours, customPerDay: null });
    }
  };

  const setDayTime = (day, field, value) => {
    onChange({
      ...hours,
      customPerDay: { ...custom, [day]: { ...custom[day], [field]: value } },
    });
  };

  // Días activos ordenados según WEEK_DAYS para el preview y filas per-day.
  const activeDaysOrdered = WEEK_DAYS.filter((d) => hours.days.includes(d.value));
  const previewDays =
    activeDaysOrdered.length > 0
      ? `${dayLabel(activeDaysOrdered[0].labelKey)}–${dayLabel(
          activeDaysOrdered[activeDaysOrdered.length - 1].labelKey
        )}`
      : '—';

  return (
    <div className="sw-step">
      <h2 className="sw-step-title">{t('setupWizard.step4.title', 'Horarios de atención')}</h2>

      <fieldset className="sw-days">
        <legend className="sw-label">{t('setupWizard.step4.days', 'Días de atención')}</legend>
        <div className="sw-day-chips">
          {WEEK_DAYS.map((d) => (
            <label
              key={d.value}
              className={`sw-day-chip ${hours.days.includes(d.value) ? 'active' : ''}`}
            >
              <input
                type="checkbox"
                checked={hours.days.includes(d.value)}
                onChange={() => toggleDay(d.value)}
              />
              <span>{dayLabel(d.labelKey)}</span>
            </label>
          ))}
        </div>
        {errors.days && (
          <p className="sw-error">{t('setupWizard.errors.minOneDay', 'Elegí al menos 1 día')}</p>
        )}
      </fieldset>

      {!custom && (
        <div className="sw-time-row">
          <label className="sw-field">
            <span className="sw-label">{t('setupWizard.step4.open', 'Apertura')}</span>
            <input
              type="time"
              className="sw-input"
              value={hours.openTime}
              onChange={(e) => setGlobalTime('openTime', e.target.value)}
            />
          </label>
          <label className="sw-field">
            <span className="sw-label">{t('setupWizard.step4.close', 'Cierre')}</span>
            <input
              type="time"
              className="sw-input"
              value={hours.closeTime}
              onChange={(e) => setGlobalTime('closeTime', e.target.value)}
            />
          </label>
        </div>
      )}

      <label className="sw-toggle">
        <input
          type="checkbox"
          checked={!!custom}
          onChange={(e) => toggleCustom(e.target.checked)}
        />
        <span>{t('setupWizard.step4.customize', 'Personalizar por día')}</span>
      </label>

      {custom && (
        <div className="sw-per-day">
          {activeDaysOrdered.map((d) => (
            <div key={d.value} className="sw-per-day-row">
              <span className="sw-per-day-label">{dayLabel(d.labelKey)}</span>
              <input
                type="time"
                className="sw-input"
                value={custom[d.value]?.openTime || ''}
                onChange={(e) => setDayTime(d.value, 'openTime', e.target.value)}
              />
              <span className="sw-per-day-sep">–</span>
              <input
                type="time"
                className="sw-input"
                value={custom[d.value]?.closeTime || ''}
                onChange={(e) => setDayTime(d.value, 'closeTime', e.target.value)}
              />
            </div>
          ))}
        </div>
      )}

      {errors.hours && (
        <p className="sw-error">
          {t('setupWizard.errors.openBeforeClose', 'La apertura debe ser antes del cierre')}
        </p>
      )}

      {!custom && (
        <p className="sw-preview">
          {t('setupWizard.step4.preview', {
            days: previewDays,
            open: hours.openTime,
            close: hours.closeTime,
            defaultValue: 'Disponible {{days}} de {{open}} a {{close}}',
          })}
        </p>
      )}
    </div>
  );
}

export default StepHours;
